import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Decouples "open the feedback rating survey" from where the modal lives. The
 * modal is mounted once in the app shell (FeedbackRatingComponent); any
 * component (e.g. the user menu) can request it to open via `open()`.
 */
@Injectable({ providedIn: 'root' })
export class FeedbackUiService {
  private readonly _open$ = new Subject<void>();
  readonly open$ = this._open$.asObservable();

  open(): void {
    this._open$.next();
  }
}
